<template>
  <v-container class="wrapper" fluid grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex md5 sm6 xs12>
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 6 : 2}`"
            class="category-select"
            @click="setClientType('company')">
            <img src="../assets/icons/building-light.svg" alt="Building icon" class="mb-3">
            <br>
            <span class="type-span">
              {{ $t('business_entity') }}
            </span>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex md5 sm6 xs12>
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 6 : 2}`"
            class="category-select"
            @click="setClientType('private')">
            <img src="../assets/icons/user-light.svg" alt="User icon" class="mb-3">
            <br>
            <span class="type-span">
              {{ $t('private_person') }}
            </span>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex class="text-xs-center" style="font-size: 20px" xs12>
        <a @click="setClientType('')">
          {{ $t('upload_signed_documents') }}
        </a>
        <!--<v-hover>-->
          <!--<v-card-->
            <!--slot-scope="{ hover }"-->
            <!--:class="`elevation-${hover ? 6 : 2}`"-->
            <!--class="category-select"-->
            <!--@click="$router.push({ name: 'signed-document-upload-form' })">-->
            <!--<img src="../assets/icons/file-signature-light.svg" alt="Document sign icon" class="mb-3">-->
            <!--<br>-->
            <!--<span class="type-span">-->
              <!--{{ $t('upload_signed_documents') }}-->
            <!--</span>-->
          <!--</v-card>-->
        <!--</v-hover>-->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Home',

  methods: {
    ...mapMutations({
      storeClientType: 'clients/storeType',
    }),

    setClientType(type) {
      if (type === 'company') {
        this.$router.push({ name: 'company-form' });
      } else if (type === 'private') {
        this.$router.push({ name: 'private-person-form' });
      } else {
        this.$router.push({ name: 'signed-document-upload-form' });
      }
    },
  },
};
</script>

<style scoped>
  .wrapper {
    padding: 0 132px;
  }

  .category-select {
    height: 251px;
    width: 100%;
    max-width: 251px;
    background: #F3F3F3;
    font-size: 18px;
    margin: 0 auto 82px auto;
    text-align: center;
    padding-top: 4rem;
  }

  .type-span {
    display: block;
    max-width: 180px;
    margin: 0 auto;
  }

  .category-select:hover {
    cursor: pointer;
  }

  @media only screen and (max-width: 700px) {
    .wrapper {
      padding: 0 24px;
    }

    .category-select {
      padding-bottom: 24px;
    }
  }
</style>
